import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import config from '../../admin/config';
import { HookDirective } from '../../common/core/hook';
import { useState } from '../../common/core/hooks';
import { StringParam } from '../../common/state/route';
import { RouteService, useQueryParam } from '../../common/state/route.service';

@Component({
  host: { class: 'rv-grid xlarge outer rv-center' },
  selector: 'email-sent',
  styleUrls: ['./email-sent.component.scss'],
  templateUrl: './email-sent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailSentComponent extends HookDirective {
  constructor(
    readonly _cdr: ChangeDetectorRef,
    private readonly routeService: RouteService,
  ) {
    super(_cdr);
  }

  get _() {
    const [envIsZelis] = useState<boolean>(!!config.envIsZelis);

    const [email] = useQueryParam(this.routeService, new StringParam('email'));

    return { envIsZelis, email };
  }

  openIntercom() {
    Intercom('show');
  }
}
